import { Injectable } from '@angular/core';
import { DatabaseGwService } from '../database-gw.service';

@Injectable({
  providedIn: 'root'
})
export class InvoiceDetailService extends DatabaseGwService {
  URL_PATH: string = "/invoice-details";
}
